/**
 * Maps API response data to cleaning metrics values
 * @param {Object} apiResponse - The CIP API response containing all metric data
 * @returns {Object} Formatted metrics with values, targets, and ranges
 */
export const getCleaningMetricsValues = (apiResponse) => {
  const {
    operational_time,
    water_recovery,
    flux_lmh,
    backwash_interval_mins,
    avg_duration_between_ceb_hrs,
    flux_lmh_target,
    backwash_interval_target_mins,
    backwash_interval_min_mins,
    backwash_interval_max_mins,
    avg_duration_between_ceb_target_hrs,
  } = apiResponse;

  return {
    operational_time: { value: operational_time },
    water_recovery: { value: water_recovery },
    bw_interval: {
      value: backwash_interval_mins,
      target: backwash_interval_target_mins,
      acceptable_range:
        backwash_interval_min_mins && backwash_interval_max_mins
          ? `${backwash_interval_min_mins} - ${backwash_interval_max_mins}`
          : null,
    },
    flux: {
      value: flux_lmh,
      target: flux_lmh_target,
      acceptable_range: null,
    },
    ceb_interval: {
      value: avg_duration_between_ceb_hrs,
      target: avg_duration_between_ceb_target_hrs,
      acceptable_range: null,
    },
  };
};
